import { format } from "date-fns";

export function formatDateTime(iso: Date | string, formatString: string) {
  return format(new Date(iso), formatString);
}
